import {useCallback} from 'react';

import {PULLING_PARENT_EVENTS} from '@/app/auth/events/PullingParentEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackSelectCreateTeenErrorRetry = useCallback(
    (kidUuid: string) => {
      trackEvent(PULLING_PARENT_EVENTS.SELECT_CREATE_TEEN_ERROR_RETRY, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          id: kidUuid ?? '',
        },
      });
    },
    [trackEvent],
  );

  const trackSelectCreateTeenErrorCS = useCallback(
    (kidUuid: string) => {
      trackEvent(PULLING_PARENT_EVENTS.SELECT_CREATE_TEEN_ERROR_CS, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        FamilyMember: {
          id: kidUuid ?? '',
        },
      });
    },
    [trackEvent],
  );

  return {trackSelectCreateTeenErrorRetry, trackSelectCreateTeenErrorCS};
};
